import type { OptionProps, OptionState } from '@fluentui-copilot/react-input-listbox';
import type { DesignVersion } from '@fluentui-copilot/react-provider';
import type { Button, ComponentProps, ComponentState, Persona, Slot, TooltipProps } from '@fluentui/react-components';

export type GroundingMenuItemSlots = {
  root: NonNullable<Slot<'div'>>;
  persona: NonNullable<Slot<typeof Persona>>;
  submenuButton?: Slot<typeof Button>;
  submenuButtonTooltip?: Slot<TooltipProps>;
};

/**
 * GroundingMenuItem Props
 */
export type GroundingMenuItemProps = ComponentProps<Partial<GroundingMenuItemSlots>, 'persona'> &
  Pick<OptionProps, 'disabled' | 'onOptionSelect' | 'value'> &
  DesignVersion;

/**
 * State used in rendering GroundingMenuItem
 */
export type GroundingMenuItemState = ComponentState<GroundingMenuItemSlots> &
  Pick<OptionState, 'disabled' | 'selected'> &
  Pick<Required<GroundingMenuItemProps>, 'designVersion'>;
